module.exports = __webpack_public_path__ + "img/Weapon_45.87c0b79f.png";